import { ParkingLocation } from "./types";

export const mockParkingLocations: ParkingLocation[] = [
  {
    id: "1",
    name: "Downtown Miami Hub",
    address: "1200 Brickell Avenue, Miami, FL",
    businessModel: "Miami Operations",
    city: "Miami",
    state: "FL",
    country: "United States"
  },
  {
    id: "2",
    name: "Austin Central Station",
    address: "500 E 7th Street, Austin, TX",
    businessModel: "Austin Operations",
    city: "Austin",
    state: "TX",
    country: "United States"
  },
  {
    id: "3",
    name: "Phoenix Airport Depot",
    address: "3400 E Sky Harbor Blvd, Phoenix, AZ",
    businessModel: "Phoenix Operations",
    city: "Phoenix",
    state: "AZ",
    country: "United States"
  },
  {
    id: "4",
    name: "Seattle Waterfront Lot",
    address: "1001 Alaskan Way, Seattle, WA",
    businessModel: "Seattle Operations",
    city: "Seattle",
    state: "WA",
    country: "United States"
  },
  {
    id: "5",
    name: "Boston Common Garage",
    address: "0 Charles Street, Boston, MA",
    businessModel: "Boston Operations",
    city: "Boston",
    state: "MA",
    country: "United States"
  },
  {
    id: "6",
    name: "Denver Union Station",
    address: "1701 Wynkoop Street, Denver, CO",
    businessModel: "Denver Operations",
    city: "Denver",
    state: "CO",
    country: "United States"
  },
  {
    id: "7",
    name: "San Diego Gaslamp Quarter",
    address: "701 Fifth Avenue, San Diego, CA",
    businessModel: "San Diego Operations",
    city: "San Diego",
    state: "CA",
    country: "United States"
  },
  {
    id: "8",
    name: "San Francisco Embarcadero",
    address: "Ferry Building, San Francisco, CA",
    businessModel: "San Francisco Operations",
    city: "San Francisco",
    state: "CA",
    country: "United States"
  },
  {
    id: "9",
    name: "Nashville Broadway Hub",
    address: "501 Broadway, Nashville, TN",
    businessModel: "Nashville Operations",
    city: "Nashville",
    state: "TN",
    country: "United States"
  },
  {
    id: "10",
    name: "Atlanta Midtown Center",
    address: "1180 Peachtree Street NE, Atlanta, GA",
    businessModel: "Atlanta Operations",
    city: "Atlanta",
    state: "GA",
    country: "United States"
  },
  {
    id: "11",
    name: "Las Vegas Strip Station",
    address: "3799 Las Vegas Blvd S, Las Vegas, NV",
    businessModel: "Las Vegas Operations",
    city: "Las Vegas",
    state: "NV",
    country: "United States"
  },
  {
    id: "12",
    name: "Portland Downtown Depot",
    address: "800 SW 6th Avenue, Portland, OR",
    businessModel: "Portland Operations",
    city: "Portland",
    state: "OR",
    country: "United States"
  }
];